<template>
  <div class="vd-gl-content">
    <a-row class="vd-toolbar">
      <a-col class="vd-toolbar-right vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <a-button type="primary" icon="plus" @click="showSearchTableModal">
              新建字段
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

    <a-table row-key="id" :data-source="list" :pagination="false">
      <a-table-column title="名称" data-index="name" />
      <a-table-column title="解释" data-index="alias" />
      <a-table-column title="联动等级" align="center" data-index="is_linkage">
        <template slot-scope="item">
          {{ linkageList[item]['value'] }}
        </template>
      </a-table-column>
      <a-table-column title="模糊匹配" align="center" data-index="is_search">
        <template slot-scope="item">
          <a-icon :type="item ? 'check' : 'close'" />
        </template>
      </a-table-column>
      <a-table-column title="必填" align="center" data-index="is_require">
        <template slot-scope="item">
          <a-icon :type="item ? 'check' : 'close'" />
        </template>
      </a-table-column>
      <a-table-column title="检测重复" align="center" data-index="is_repeat">
        <template slot-scope="item">
          <a-icon :type="item ? 'check' : 'close'" />
        </template>
      </a-table-column>
      <a-table-column title="操作" align="center">
        <template slot-scope="item">
          <a-popconfirm
            placement="top"
            ok-text="删除"
            cancel-text="取消"
            title="是否删除该条字段信息。"
            @confirm="removeItem(item.id)"
          >
            <a-icon class="common-icon" type="delete" />
          </a-popconfirm>
        </template>
      </a-table-column>
    </a-table>

    <a-modal
      title="创建新数据表"
      :visible="searchTableVisible"
      ok-text="确定"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rule"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="字段类型" prop="type">
          <a-select
            style="width: 216px"
            placeholder="数据类型"
            v-model="form.type"
            :disabled="!$HelperUtil.isEmpty(form.id)"
            allowClear
          >
            <a-select-option
              v-for="type in fieldType"
              :value="type.type"
              :key="type.type"
            >
              {{ type.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="名称" prop="name">
          <a-input
            class="vd-input-s"
            v-model="form.name"
            placeholder="请输入字段名"
            allowClear
          />
        </a-form-model-item>
        <a-form-model-item label="注释" prop="alias">
          <a-input
            class="vd-input-s"
            v-model="form.alias"
            placeholder="请输入字段注释"
            allowClear
          />
        </a-form-model-item>

        <a-form-model-item label="数据联动" prop="is_linkage">
          <a-select
            style="width: 108px"
            placeholder="数据类型"
            v-model="form.is_linkage"
            @change="onLinkageChange"
            :disabled="form.is_search"
            allowClear
          >
            <a-select-option
              v-for="type in linkageList"
              :value="type.type"
              :key="type.type"
            >
              {{ type.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="模糊匹配" prop="is_search">
          <a-radio-group
            v-model="form.is_search"
            @change="onSearchChange"
            :disabled="form.is_linkage > 0"
          >
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false"> 否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="必填" prop="is_require">
          <a-radio-group v-model="form.is_require">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false"> 否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="检测重复" prop="is_repeat">
          <a-radio-group v-model="form.is_repeat">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false"> 否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  auto_get_table_field,
  auto_modify_table_field,
  remove_item,
} from '@/api/auto'

export default {
  name: 'Table',
  data() {
    const fieldType = [
      { value: '字符串类型', type: 0 },
      { value: '整数类型', type: 1 },
    ]
    const linkageList = [
      { value: '无联动关系', type: 0 },
      { value: '一级联动', type: 1 },
      { value: '二级联动', type: 2 },
      { value: '三级联动', type: 3 },
      { value: '四级联动', type: 4 },
      { value: '五级联动', type: 5 },
    ]
    return {
      fieldType,
      linkageList,
      table_id: undefined,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      searchTableVisible: false,
      rule: {
        type: [{ required: true, message: '请选择字段类型', trigger: 'blur' }],
        name: [{ required: true, message: '请输入字段名', trigger: 'blur' }],
        alias: [{ required: true, message: '请输入字段注释', trigger: 'blur' }],
        is_search: [
          { required: true, message: '请选择过期时间', trigger: 'blur' },
        ],
        is_require: [
          { required: true, message: '请选择过期时间', trigger: 'blur' },
        ],
        is_repeat: [
          { required: true, message: '请选择过期时间', trigger: 'blur' },
        ],
        is_linkage: [
          { required: true, message: '请选联动等级', trigger: 'blur' },
        ],
      },
      list: [],
      form: {
        id: undefined,
        type: undefined,
        name: undefined,
        alias: undefined,
        is_linkage: undefined,
        is_search: false,
        is_require: false,
        is_repeat: false,
      },
    }
  },
  created() {
    if (!this.$HelperUtil.isEmpty(this.$route.query)) {
      this.table_id = parseInt(this.$route.query.id)
    }
    this.getData()
  },
  methods: {
    getData() {
      auto_get_table_field({
        table_id: this.table_id,
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
        }
      })
    },
    showSearchTableModal() {
      this.searchTableVisible = !this.searchTableVisible
    },
    // 移除字段
    removeItem(fieldId) {
      remove_item({ id: fieldId }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.getData()
        }
      })
    },
    handleOk() {
      // 输入检测
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          auto_modify_table_field({
            table_id: this.table_id,
            id: this.id,
            name: this.form.name,
            alias: this.form.alias,
            type: this.form.type,
            line_show: this.form.line_show,
            is_search: this.form.is_search,
            is_repeat: this.form.is_repeat,
            is_require: this.form.is_require,
            is_linkage: this.form.is_linkage,
            weigh: this.form.weigh,
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success('创建成功')
              this.getData()
              this.searchTableVisible = !this.searchTableVisible
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    handleCancel() {
      this.searchTableVisible = !this.searchTableVisible
      this.form.name = this.form.alias = undefined
    },
    onSearchChange(e) {
      // 选择模糊匹配 设置为无联动关系 并且禁用 联动下拉选择
      this.form.is_linkage = e.target.value ? 0 : this.form.is_linkage

      this.$refs.ruleForm.clearValidate()
    },
    onLinkageChange(e) {
      this.form.is_linkage = e
      if (e > 0) this.form.is_search = false

      this.$refs.ruleForm.clearValidate()
    },
  },
}
</script>

<style scoped></style>
